export const CONSTANTS = {
  PAGE_SIZE_OPTIONS: [25, 50, 100],
  TABLE_NO_DATA: 'No data found',
  TEMPLATE_DATE_TIME_FORMAT: 'DD-MMM-YY HH:mm',
  TEMPLATE_DATE_ONLY_FORMAT: 'DD-MMM-YY',
  UPDATE_CONFIRMED_TRIP_PERMISSION: 'UPDATE_CONFIRMED_TRIP',
  PRIVACY_POLICY_URL: 'https://www.alphastarav.com/en/PrivacyPolicy.aspx',
  pageSizeOptions: [25, 50, 100],
};
